var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "updateRoomRateModal",
        title: "Update Room Rate",
        centered: "",
        "hide-footer": "",
        "hide-header-close": "",
        size: "lg",
      },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "entry-info" },
            [
              _c("b-form-select", {
                staticClass: "form-control",
                attrs: {
                  title: "Payment Method",
                  required: "",
                  options: _vm.availableOptions,
                },
                model: {
                  value: _vm.rateType,
                  callback: function ($$v) {
                    _vm.rateType = $$v
                  },
                  expression: "rateType",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "input-group" },
            [
              _vm.rateType === 2
                ? _c("currency-input", {
                    attrs: {
                      name: "Rate",
                      amount: _vm.rate,
                      size: 10,
                      fieldState: _vm.fieldState.rate,
                    },
                    on: {
                      "update:amount": function ($event) {
                        _vm.rate = $event
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.reservation && _vm.rateType == 1
        ? _c(
            "div",
            { staticClass: "mt-4 room-rates-table-container" },
            [
              _c("b-table", {
                staticClass: "room-rates-table",
                attrs: { fields: _vm.fields, items: _vm.roomRates },
                scopedSlots: _vm._u(
                  [
                    _vm._l(_vm.fields, function (field, index) {
                      return {
                        key: `head(${field.key})`,
                        fn: function (data) {
                          return [
                            _c("span", {
                              key: index,
                              domProps: { innerHTML: _vm._s(data.label) },
                            }),
                          ]
                        },
                      }
                    }),
                    _vm._l(_vm.fields, function (field, index) {
                      return {
                        key: `cell(${field.key})`,
                        fn: function (data) {
                          return [
                            _c("b-form-input", {
                              key: index,
                              staticClass: "form-control input-page-rate",
                              attrs: {
                                value: data.item[field.key],
                                state: _vm.fieldState.page_rate[field.page_id],
                                type: "number",
                              },
                              on: {
                                input: (e) =>
                                  _vm.onUpdatePageRate(field.page_id, e),
                              },
                            }),
                          ]
                        },
                      }
                    }),
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "mt-3 mr-4",
          attrs: { variant: "outline-danger", disabled: _vm.loading },
          on: { click: _vm.hide },
        },
        [_vm._v("\n    Close\n  ")]
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "mt-3",
          attrs: {
            variant: "success",
            disabled: !_vm.isValidRates() || _vm.loading,
          },
          on: { click: _vm.updateRate },
        },
        [_vm._v("\n    Update\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }